/**
 * The colours the household's members wear on a todo.
 *
 * The module's own copy, so it imports nothing from another module (the
 * independence rule — the same reason `datetime.ts` is a local copy). The values
 * match the agenda's parent palette on purpose: a person reads as the same colour
 * in Taken as in the Agenda (🔵 Jurren / 🟠 Olga), so the two screens agree at a
 * glance. Colour is never the only cue — the name always sits beside the dot.
 */
const MEMBER_PALETTE = ['#2563eb', '#ea7317', '#7a5cd0', '#2e9e8f'] as const;

/** A member's colour from their position in the household, or null if unassigned. */
export function memberColor(userId: string | null, memberIds: string[]): string | null {
  if (!userId) return null;
  const i = memberIds.indexOf(userId);
  return MEMBER_PALETTE[(i >= 0 ? i : 0) % MEMBER_PALETTE.length]!;
}
